import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import styled from 'styled-components';
import { Box, Checkbox, Chip, FormControl, InputLabel } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { ModalCloseIcon } from '../Icons';

const StyledAutoComplete = styled(Autocomplete)<{ error?: boolean; disabled?: boolean }>`
	& .MuiInputBase-root {
		border: 1.5px solid ${(props) => (props?.error ? 'red' : '#e9e9e9')} !important;
		border-radius: 4px;
		width: 100%;
		&:hover {
			border: 1.5px solid ${(props) => (props?.error ? 'red' : '#e9e9e9')} !important;
		}
		min-height: 36px;
		padding-left: 10px;
		padding-top: 4px;
		padding-bottom: 4px;
	}
	& .MuiChip-root {
		background: #fffdf5;
		border: 1px solid #ffdf80;
		border-radius: 4px;
		& .MuiChip-deleteIcon {
			color: #ffbe00 !important;
			margin-left: 2px;
		}
	}
`;

const StyledLabel = styled(Box)`
	color: var(--color-font-grey);
	font-size: 14px;
	font-weight: 600;
	line-height: 15.6px;
	span {
		color: #f26184;
		margin-left: 4px;
	}
`;

interface Option {
	id: string;
	value: string;
	disable?: boolean;
}

interface Props {
	selectedOptions: Option[];
	setSelectedOptions: (data: Option[]) => void;
	options: Option[];
	onChange: (value: Option[]) => void;
	label?: string;
	required?: boolean;
	disabled?: boolean;
	placeholder?: string;
	style?: any;
}
const CustomChip = styled(Chip)`
	/* Add your custom styles for the chip here */
	display: inline-block;
	background-color: #e0e0e0;
	color: #333;
	border-radius: 16px;
	padding: 4px 8px;
	margin-right: 8px;
`;

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const MultiSelect: React.FC<Props> = ({
	selectedOptions,
	setSelectedOptions,
	options,
	onChange,
	label = '',
	required = false,
	disabled = false,
	placeholder = 'Type City...',
	style = { width: '569px', height: 'auto' },
}) => {
	const ids = selectedOptions?.map((option) => option?.id);

	const handleCheckboxChange = (option: any, optionState: boolean) => {
		if (optionState) {
			const data: Option[] = selectedOptions?.filter((item) => item?.id !== option?.id);
			setSelectedOptions(data);
		}
	};

	return (
		<Stack spacing={3} sx={{ width: '100%', minHeight: '36px' }}>
			<StyledAutoComplete
				multiple
				id="checkboxes-tags-demo"
				disableCloseOnSelect
				options={options}
				value={selectedOptions}
				onChange={(event, newValue) => {
					//@ts-ignore
					setSelectedOptions(newValue);
				}}
				//@ts-ignore
				getOptionLabel={(option) => option?.value}
				//@ts-ignore
				isOptionEqualToValue={(option, value) => option?.id === value?.id}
				//@ts-ignore
				renderOption={(props, option, { selected }) => {
					return (
						<li style={{ display: 'flex', justifyContent: 'space-between' }} {...props}>
							{/* @ts-ignore */}
							<span>{option?.value}</span>
							<Checkbox
								icon={icon}
								checkedIcon={checkedIcon}
								style={{ marginRight: 8 }}
								checked={selected}
							/>
						</li>
					);
				}}
				renderInput={(params: TextFieldProps) => {
					return (
						<div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
							<StyledLabel style={disabled ? { color: 'var(--gray-g-400, #ACACAC)' } : {}}>
								{label}
								{required ? <span>*</span> : null}
							</StyledLabel>
							<FormControl sx={style}>
								<TextField
									{...params}
									variant="standard"
									InputProps={{ ...params.InputProps, disableUnderline: true }}
									placeholder={placeholder}
								/>
							</FormControl>
						</div>
					);
				}}
			/>
		</Stack>
	);
};

export default MultiSelect;
